import react from "react";

import Librino1 from "../images/commercials/Librino/LIBRINO_BIENNALE_01 Large.jpeg";
import Librino2 from "../images/commercials/Librino/LIBRINO_BIENNALE_02 Large.jpeg";
import Librino3 from "../images/commercials/Librino/LIBRINO_BIENNALE_03 Large.jpeg";
import Librino4 from "../images/commercials/Librino/LIBRINO_BIENNALE_04 Large.jpeg";
import Librino5 from "../images/commercials/Librino/LIBRINO_BIENNALE_05 Large.jpeg";
import Librino6 from "../images/commercials/Librino/LIBRINO_BIENNALE_06 Large.jpeg";

const Librino = () => {
    return (

        <div className="picture-gallery">
            <div className="photo-column">
                <div className="single portrait">
                    <img src={Librino1} alt="Librino Biennale - Image 1"/>
                </div>
                <div className="single portrait">
                    <img src={Librino2} alt="Librino Biennale - Image 2"/>
                </div>
                <div className="single portrait">
                    <img src={Librino3} alt="Librino Biennale - Image 3"/>
                </div>
                <div className="single portrait">
                    <img src={Librino4} alt="Librino Biennale - Image 4"/>
                </div>
                <div className="single portrait">
                    <img src={Librino5} alt="Librino Biennale - Image 5"/>
                </div>
                <div className="single portrait">
                    <img src={Librino6} alt="Librino Biennale - Image 6"/>
                </div>
            </div>
        </div>
    );
}

export default Librino;